import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">热度榜单</h2>
          <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">实时热度排名</span>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => {
            const rankColor = item.rank === 1 ? 'bg-accent-500 text-background-50 dark:text-foreground-950' : item.rank === 2 ? 'bg-accent-400 text-background-50 dark:text-foreground-950' : item.rank === 3 ? 'bg-accent-300 text-accent-900' : 'bg-background-200 text-foreground-600';
            return (
              <div key={item.id} className="flex items-center gap-4 p-4 rounded-lg hover:bg-background-50 transition-colors cursor-pointer group border-b border-background-200 last:border-b-0">
                <div className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-heading shrink-0 ${rankColor}`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-500">{item.genre}</p>
                </div>

                <div className="text-right shrink-0">
                  <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.heat}</p>
                  <div className="flex items-center justify-end gap-1 mt-0.5">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.status}</span>
                    <span className={`text-xs ${item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'}`}>
                      {item.trend === 'up' ? '↑' : '→'}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}